import {Store} from "../models/";
import {MarkerClusterer} from "@googlemaps/markerclusterer";

export class MarkerVisibilityController {
  private idleListener?: google.maps.MapsEventListener;

  // =========================
  // 🔹 SYNC MARKERS ON MAP MOVEMENT
  // =========================

  syncMarkersOnBoundsChange(markerCluster?: MarkerClusterer, map?: google.maps.Map, stores?: Store[]) {
    if (!map || !markerCluster || !stores) {
      return;
    }

    if (this.idleListener) {
      google.maps.event.removeListener(this.idleListener);
    }

    this.idleListener = google.maps.event.addListener(map, "idle", () => {
      this.updateVisibleMarkers(map, markerCluster, stores);
    });
  }

  // =========================
  // 🔹 UPDATE VISIBLE MARKERS BASED ON BOUNDS
  // =========================

  updateVisibleMarkers(map: google.maps.Map, cluster: MarkerClusterer, stores: Store[]) {
    const bounds = map.getBounds();
    if (!bounds) {
      return;
    }

    const storesWithinBounds: Store[] = [];
    const storesOutsideBounds: Store[] = [];

    for (const store of stores) {
      const position = store.marker?.position;
      if (!position) {
        continue;
      }

      const latLng = position instanceof google.maps.LatLng ? position : new google.maps.LatLng(position as google.maps.LatLngLiteral);

      if (bounds.contains(latLng)) {
        storesWithinBounds.push(store);
      } else {
        storesOutsideBounds.push(store);
      }
    }

    const outsideMarkers = storesOutsideBounds
      .map(s => s.marker)
      .filter(Boolean);

    const insideMarkers = storesWithinBounds
      .map(s => s.marker)
      .filter(Boolean);

    cluster.removeMarkers(outsideMarkers);
    cluster.addMarkers(insideMarkers);
  }
}

export const visibilityController = new MarkerVisibilityController();